import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Hero {
  constructor(el) {
    this.el = el
    this.wrap = document.querySelector('.modules-wrap')
    if (this.wrap) this.init()
  }

  init() {
    gsap.fromTo(this.wrap,
      { y: '-20vh', opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: this.el,
          start: 'top top',
          end: 'bottom top',
          scrub: 1,
        }
      }
    )
  }
}
